import CubeIcon from "../../../public/assets/cube-outline.svg";

export default CubeIcon;
